import React, { FC, ReactNode, useContext } from "react";
import Head from "next/head";
import { TenantContext } from "v3/context/tenant";
import { SimpleHeader } from "@pepdirect/v3/ui/SimpleHeader";
import { CheckoutFooter } from "v3/components/checkout/Footer";
import { LoadingPage } from "v3/components/LoadingPage";
import { BrandConfigCustomizationsImage } from "v3/services/graphql/generated";
import { StyledPageWrapper } from "./index.styled";

interface CheckoutPageProps {
  children: ReactNode;
  title: string;
}

export const CheckoutPageWrapper: FC<CheckoutPageProps> = ({
  children,
  title,
}) => {
  const { tenant } = useContext(TenantContext);

  if (!tenant) return <LoadingPage />;

  const logo = tenant.brandConfig?.customizations?.images.find(
    (img: BrandConfigCustomizationsImage) => img.name === "logoLargeLightUrl"
  );

  return (
    <>
      <Head>
        <title>{title}</title>
      </Head>
      <StyledPageWrapper>
        <SimpleHeader
          fallbackUrl={tenant?.fallbackUrl || ""}
          logo={{ src: logo?.src || "", alt: logo?.alt || "Shop logo" }}
          type="checkout"
        />
        {children}
      </StyledPageWrapper>
      <CheckoutFooter />
    </>
  );
};
